import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { getCoprincipalAccountForMailboxInfo } from 'owa-account-source-list-store';
import { isCloudCache } from 'owa-account-source-list-internal';
import { isShadowMailboxUser } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export const categoriesCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // by default
    },
    isSupported: (mailboxInfo?: MailboxInfo) => {
        if (
            !isFeatureEnabled('tri-cc-categories') &&
            !isFeatureEnabled('cal-hide-categories-cloud-cache')
        ) {
            return true;
        }

        if (mailboxInfo) {
            const account = getCoprincipalAccountForMailboxInfo(mailboxInfo);

            // If feature is enabled, then we support categories for cloud cache accounts
            // so we don't need to do any kind of account check. Else, we will not
            // support categories for cloud cache accounts, so we will check if the account
            // is cloud cache or not.
            const cloudCacheCheck = isFeatureEnabled('tri-cc-categories')
                ? true
                : account && !isCloudCache(account) && !isShadowMailboxUser(mailboxInfo);

            if (cloudCacheCheck) {
                return true;
            }
        }

        return false;
    },
};
